<div
  data-testid="no-changes-section"
  class="checkbox-container"
  *ngIf="!chkNoChangeInvisible()"
>
  <goab-form-item labelSize="regular">
    <goab-checkbox
      [data-testid]="'no-changes-checkbox'"
      tabindex="0"
      name="item"
      text="No changes this week"
      ariaLabel="no-changes-checkbox"
      (onChange)="onNoChangesCheckboxChange($any($event))"
    ></goab-checkbox>
  </goab-form-item>
</div>
<goab-divider
  mt="l"
  mb="none"
  *ngIf="!selectedFacilityBeds()?.facilityHasSmokingPolicy"
></goab-divider>
<div
  *ngIf="!selectedFacilityBeds()?.facilityHasSmokingPolicy"
  data-testid="facility-smoking-policy-section"
  class="facility-smoking-policy-section"
>
  <goab-text
    tag="h3"
    size="heading-m"
    [attr.data-testid]="'facility-smoking-policy-heading'"
    mb="xs"
    class="reasons-for-change"
    >Does your facility have a smoking policy?</goab-text
  >
  <goab-text
    size="body-m"
    tag="div"
    mt="none"
    mb="l"
    [attr.data-testid]="'facility-smoking-policy-description'"
    >Please keep a copy of your policy handy in case it's requested for
    verification.</goab-text
  >
  <goab-form-item requirement="required" labelSize="regular" mt="m">
    <goab-radio-group
      name="smoking-policy"
      [attr.data-testid]="'smoking-policy-radio-group'"
      (onChange)="onSmokingPolicyChange($event)"
      [value]="facilitySmokingPolicy()"
    >
      <goab-radio-item
        [attr.data-testid]="'smoking-policy-yes-radio-item'"
        tabindex="0"
        radioItemHtmlLabel
        value="True"
        [customRadioHtmlLabel]="facilitySmokingPolicyYesLabel"
      ></goab-radio-item>
      <goab-radio-item
        [attr.data-testid]="'smoking-policy-no-radio-item'"
        tabindex="0"
        value="False"
        radioItemHtmlLabel
        [customRadioHtmlLabel]="facilitySmokingPolicyNoLabel"
        style="margin-top: -3px"
      ></goab-radio-item>
    </goab-radio-group>
  </goab-form-item>
</div>
<goab-divider mt="2xl"></goab-divider>

<div data-testid="submit-section" class="button-container">
  <goab-button
    preventFocusScroll
    [targetSelector]="'goa-button'"
    [data-testid]="'save-for-later-button'"
    tabindex="0"
    class="save-for-later-button"
    type="tertiary"
    size="compact"
    [disabled]="!isSaveLaterable()"
    (onClick)="onSaveLater()"
    [attr.type]="'button'"
  >
    Complete this entry later
  </goab-button>
  <goab-button
    preventFocusScroll
    [targetSelector]="'goa-button'"
    [data-testid]="'submit-button'"
    tabindex="0"
    type="primary"
    size="compact"
    variant="normal"
    [disabled]="!isSubmittable()"
    (onClick)="onSubmit()"
    [attr.type]="'button'"
  >
    Finalize and submit
  </goab-button>
</div>
